import script from "./CRM21_002INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM21_002INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__